export interface CartWorkflowStepValidationResults {
    isValid: boolean;
    messages: string[];
}

export const DefaultCartWorkflowStepValidationResults = (): CartWorkflowStepValidationResults => {
    return {
        isValid: true,
        messages: []
    };
};
